(function avisVerifier() {
  const currentPage = window.location.pathname.replace('.html', '').split('?')[0];
  const URL_REVIEW = `${currentPage}.reviews.json`;
  const URL_INFOSITE = `${currentPage}.reviews-siteInfo.json`;

  const getData = async (PATH, type = 'json') => {
    try {
      const response = await fetch(PATH);
      return response.status === 200
        ? getResponse(response, type)
        : Promise.resolve(type == 'json' ? [] : ';');
    } catch (error) {
      return Promise.resolve(type == 'json' ? [] : ';');
    }
  };

  const getResponse = (response, type) => {
    return type == 'json' ? response.json() : response.text();
  };

  const infoSiteToObject = (str) => {
    str = str.split(';');
    return { globalRate: str[1], globalReview: str[0] };
  };

  const getCustomReviews = async () => {
    const reviews = await getData(URL_REVIEW);
    return reviews.map((review) => ({
      review: review.review_content,
      rate: review.review_rate,
      firstname: review.author_firstname,
      lastname: review.author_lastname,
      review_date: review.review_date,
    }));
  };

  const getGlobalRateAndReview = async () => {
    const response = await getData(URL_INFOSITE);
    const siteInfo = Array.isArray(response) ? response[0] : response;

    return {
      globalRate: siteInfo.five_year?.average,
      globalReview: siteInfo.five_year?.count_total
    }
  };

  const getPercentRate = (rate) => (rate / 5) * 100 + '%';
  const fomatDate = (date) => new Date(date).toLocaleDateString('fr');

  window.GlobalSite = window.GlobalSite || {};
  const exportToGlobalSite = GlobalSite.checkDependency('GlobalSite.exportToGlobalSite');
  exportToGlobalSite({ getGlobalRateAndReview, getCustomReviews, getPercentRate, fomatDate });
})();
